import React, { useEffect } from "react";
import "./App.css";
import { Route, Routes, useNavigate } from "react-router-dom";
import axios from "axios";
import ModalComponent from "./components/Tenant/ModalComponent/ModalComponent";
import { useState } from "react";
import LoginAdmin from "./screens/Admin/LoginAdmin/LoginAdmin";
import AdminHome from "./screens/Admin/AdminHome/AdminHome";
import toast, { Toaster } from "react-hot-toast";
import { useLocation } from "react-router-dom";
import Login from "./screens/Tenant/Login/Login";
import TenantHome from "./screens/Tenant/TenantHome/TenantHome";
import NotFound from "./components/NotFound";
import { useFetchVendorsThemeByNameMutation } from "./features/admin/vendorTheme/vendorThemeApi";
import Loader from "./components/Loader/Loader";
import ErrorBoundry from "./components/ErrorBoundry/ErrorBoundry";
import DataDeletion from "./screens/Tenant/DataDeletion/DataDeletion";
import PrivacyPolicy from "./screens/Tenant/PrivacyPolicy/PrivacyPolicy";
import { useVerifyUserSessionMutation } from "./features/admin/userSession/userSessionApi";
import { tenantLogOut } from "./features/tenant/tenantAuth/tenantAuthSlice";
import { useDispatch } from "react-redux";

axios.interceptors.request.use((config) => {
  config.headers['ngrok-skip-browser-warning'] = 'any-value';
  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      window.dispatchEvent(new Event('session-expired'));
    }
    return Promise.reject(error);
  }
);

function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const accessToken =
    typeof sessionStorage != "undefined"
      ? sessionStorage.getItem("access_token")
      : null;

  const [
    getVendorTheme,
    {
      data: vendorThemeData,
      isLoading: vendorThemeIsLoading,
      isError: vendorThemeIsError,
      error: vendorThemeError,
    },
  ] = useFetchVendorsThemeByNameMutation();

  const [
    verifyUserSession,
    {
      isLoading: verifyUserSessionIsLoading,
      data: verifyUserSessionData,
    },
  ] = useVerifyUserSessionMutation();

  const checkSession = async () => {
    let response = null;

    let payload = {
      token: accessToken,
    };

    const vendorData = JSON.parse(sessionStorage.getItem("vendorData"));

    if (vendorData?.tenant_id) {
      payload.tenant_id = vendorData?.tenant_id;
    }

    try {
      response = await verifyUserSession(payload).unwrap();
    } catch (error) {
      response = error;
    }

    // console.log(response);
    // return;
    if (response?.status != 200) {
      let tenantName = vendorThemeData?.body?.tenant_name;

      sessionStorage.clear();
      dispatch(tenantLogOut());

      if (location?.pathname?.indexOf("/genefied") == -1 || !tenantName) {
        window.location.href = "/";
      } else {
        window.location.href = `/genefied/${tenantName}/`;
      }

      toast.error("Session expired, please login again");
    }
  };

  useEffect(() => {
    // if (accessToken) {
    //   checkSession();
    // }
    const path = location.pathname.split("/");
    if (path.length >= 2 && path[1] === "genefied" && path[2]) {
      // setTenantName(path[2]);
      getVendorTheme({
        params: path[2],
      });
    }
  }, []);

  // console.log(vendorThemeData);

  const [authorized, setAuthorized] = useState(() => {
    return sessionStorage.getItem("authorized")
      ? sessionStorage.getItem("authorized")
      : false;
  });

  const [tenantAuthorized, setTenantAuthorized] = useState(() =>
    sessionStorage.getItem("authorizedTenant") ? true : false,
  );

  const [sessionExpiredModalOpen, setSessionExpiredModalOpen] = useState(false);

  useEffect(() => {
    const handleSessionExpired = () => {
      const path = location.pathname.split("/");
      if (path.length >= 2 && path[1] === "genefied" && path[2]) {
        setSessionExpiredModalOpen(true);
        setTimeout(() => {
          sessionStorage.clear();
          dispatch(tenantLogOut());
          let tenantName = vendorThemeData?.body?.tenant_name || path[2];
          window.location.href = `/genefied/${tenantName}/`;
        }, 1500);
      }
    };

    window.addEventListener('session-expired', handleSessionExpired);
    return () => window.removeEventListener('session-expired', handleSessionExpired);
  }, [location.pathname, vendorThemeData, dispatch]);

  useEffect(() => {
    const path = location.pathname.split("/");
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.getElementsByTagName("head")[0].appendChild(link);
    }
    // link.href = "https://www.genefiedtech.com/assets/images/favicon.ico.png";


    if (path.length >= 2 && path[1] === "genefied" && path[2]) {
      // console.log("path" ,path);
      link.href =

        vendorThemeData?.body?.logo?.length > 0 && vendorThemeData?.body?.logo[0];
      document.title = `${vendorThemeData?.body?.tenant_name?.toUpperCase()} | Genefied SAAS`;
    } else {
      console.log("admin");
      link.href = "https://www.genefiedtech.com/assets/images/favicon.ico.png";
      document.title = "Genefied - SAAS ";

    }
    const text1 = "SAAS";
    const text2 = "GENEFIED";
    const styledText1 = `%c${text1}`;
    const styledText2 = `%c${text2}`;
    const gradient = `font-size: 24px; background: linear-gradient(45deg, #ff00ff, #00ffff, #ffff00, #ff00ff); color: transparent; -webkit-background-clip: text; background-clip: text;`;

    console.log(styledText1, gradient);
    console.log(styledText2, gradient);
  }, [vendorThemeData]);



  return (
    <div>
      <Toaster />
      <ModalComponent size="md" show={sessionExpiredModalOpen} setShow={setSessionExpiredModalOpen} showClose={false}>
        <div className="p-6 text-center">
          <h2 className="text-xl font-semibold mb-2">Session Expired</h2>
          <p className="text-gray-600">Your session has expired. You will be redirected to the login page...</p>
        </div>
      </ModalComponent>
      <Routes>
        {/* <Route path="/counter" element={<Counter />} /> */}
        <Route
          path="/*"
          element={
            !authorized ? (
              <div>
                <LoginAdmin setAuthorized={setAuthorized} />
              </div>
            ) : (
              <div>
                <AdminHome />
              </div>
            )
          }
        />
        <Route
          path="/genefied/:tenant/*"
          element={
            !tenantAuthorized ? (
              <div>
                <Login
                  showLoading={vendorThemeIsLoading}
                  vendorThemeData={vendorThemeData}
                  setTenantAuthorized={setTenantAuthorized}
                />
              </div>
            ) : (
              <div>
                <TenantHome />
              </div>
            )
          }
        />


        {/*Data deletion policy page */}
        <Route
          path="/data-deletion/:tenant"
          element={
            <ErrorBoundry>
              <DataDeletion />
            </ErrorBoundry>
          }
        />


        <Route
          path="/privacy-policy/:tenant"
          element={
            <ErrorBoundry>
              <PrivacyPolicy />
            </ErrorBoundry>
          }
        />

        <Route path="/*" element={<NotFound />} />
        <Route path="/notfound" element={<NotFound />} />
        <Route path="/loader" element={<Loader />} />
      </Routes>
    </div>
  );
}

export default App;
